module.exports = __webpack_public_path__ + "img/AgsiftLogo.0365a762.png";